import React, { useState, useEffect, useRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Tooltip from '../Tooltip';

const CopyToClipboard = ({
  showCopyValue,
  copyValue,
  copyButtonText,
  copyIcon = 'hicon-link',
  tooltipContent = 'Copy',
  onCopyStateChange,
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    let timeoutId;

    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
        if (onCopyStateChange) onCopyStateChange(false);
      }, 3000);
    }

    return () => clearTimeout(timeoutId);
  }, [isCopied]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(copyValue).then(() => {
      setIsCopied(true);
      if (onCopyStateChange) onCopyStateChange(true);
    });
  };

  return (
    <div className="copy-to-clipboard">
      {showCopyValue && (
        <div className="copy-to-clipboard-value text-truncate">
          <input ref={inputRef} type="text" value={copyValue} readOnly />
          {copyValue}
        </div>
      )}
      <Tooltip content={!isCopied && tooltipContent} placement="top">
        <button
          type="button"
          className={cx('btn btn-link copy-to-clipboard-btn', { disabled: isCopied })}
          onClick={copyToClipboard}
        >
          {copyIcon && <span className={cx(copyIcon, { 'm-r-xxs': !!copyButtonText })} />}
          {copyButtonText}
        </button>
      </Tooltip>
    </div>
  );
};

CopyToClipboard.propTypes = {
  copyValue: T.string.isRequired,
  copyButtonText: T.node,
  showCopyValue: T.bool,
  copyIcon: T.string,
  tooltipContent: T.node,
  onCopyStateChange: T.func,
};

export default CopyToClipboard;
